/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindIngestionErrorLogsQueryResponse,
  FindIngestionErrorLogsPathParams,
} from "../types/FindIngestionErrorLogs.ts"

export const findIngestionErrorLogsQueryKey = (
  ingestionId: FindIngestionErrorLogsPathParams["ingestionId"]
) =>
  [
    {
      url: "/v1/ingestions/find-ingestion-error-logs/:ingestionId",
      params: { ingestionId },
    },
  ] as const

export type FindIngestionErrorLogsQueryKey = ReturnType<
  typeof findIngestionErrorLogsQueryKey
>

/**
 * @summary Find ingestion error logs
 * {@link /v1/ingestions/find-ingestion-error-logs/:ingestionId}
 */
export async function findIngestionErrorLogs(
  ingestionId: FindIngestionErrorLogsPathParams["ingestionId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindIngestionErrorLogsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/ingestions/find-ingestion-error-logs/${ingestionId}`,
    ...requestConfig,
  })
  return res
}

export function findIngestionErrorLogsQueryOptions(
  ingestionId: FindIngestionErrorLogsPathParams["ingestionId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findIngestionErrorLogsQueryKey(ingestionId)
  return queryOptions<
    ResponseConfig<FindIngestionErrorLogsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindIngestionErrorLogsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!ingestionId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findIngestionErrorLogs(ingestionId, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find ingestion error logs
 * {@link /v1/ingestions/find-ingestion-error-logs/:ingestionId}
 */
export function useFindIngestionErrorLogs<
  TData = ResponseConfig<FindIngestionErrorLogsQueryResponse>,
  TQueryData = ResponseConfig<FindIngestionErrorLogsQueryResponse>,
  TQueryKey extends QueryKey = FindIngestionErrorLogsQueryKey,
>(
  ingestionId: FindIngestionErrorLogsPathParams["ingestionId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindIngestionErrorLogsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findIngestionErrorLogsQueryKey(ingestionId)

  const query = useQuery(
    {
      ...findIngestionErrorLogsQueryOptions(ingestionId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
